var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-alert',{staticClass:"margin-top-30",attrs:{"closable":false,"level":"warning","message":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }